// extracted by mini-css-extract-plugin
export var button = "_jk-0";
export var donut = "_jk-1";
export var donutFill = "_jk-3";
export var donutTrack = "_jk-2";